<template>
  <Form ref="wateringForm" :model="watering" v-loading="loading" :disabled="actionType=='detail'" :rules="ruleValidate" :label-width="100" >
     <input v-model="watering.id" type="hidden"/>

    <FormItem  :label="this.$t('property.watering.areaId.label')" prop="areaId">
      <Select v-model="watering.areaId" filterable placeholder="请选择区域">
        <Option  v-for="item in model12" :value="item.id" :key="item.id">{{ item.name }}</Option>
      </Select>
     <!--<InputNumber v-model="watering.areaId" :placeholder="$t('property.watering.areaId.holder')"/>-->
    </FormItem>

    <FormItem  :label="this.$t('property.watering.wateringTime.label')" prop="wateringTime">
      <Date-picker :value="watering.wateringTime" type="datetime"  @on-change="setWTimeFormat"
                   :placeholder="this.$t('property.watering.wateringTime.holder')"></Date-picker>
    </FormItem>

    <FormItem  :label="this.$t('property.watering.wateringPeople.label')" prop="wateringPeople">
      <Select v-model="watering.wateringPeople" filterable placeholder="请选择负责人">
        <Option  v-for="item in model11" :value="item.id" :key="item.id">{{ item.name }}</Option>
      </Select>
      <!--<InputNumber v-model="watering.wateringPeople" :placeholder="$t('property.watering.wateringPeople.holder')"/>-->
    </FormItem>

    <FormItem  :label="this.$t('property.watering.remark.label')" prop="remark">
      <Input v-model="watering.remark" :placeholder="$t('property.watering.remark.holder')"/>
    </FormItem>

  </Form>
</template>
<script>
import api from '@/api'

export default {
  data () {
    return {
      model12: [],
      model11: [],
      watering: {
        id: null,
        areaId: [],
        wateringTime: null,
        wateringPeople: [],
        remark: null
      },
      loading: false,
      actionType:'add'
    }
  },
  methods: {
    setWTimeFormat(str, date){
      var datetime =  new Date(str);
      this.watering.wateringTime = str;
      console.log(str)
    },
    handleAreaList(){
      this.loading = true;
      api.property.GreenArea.listAreaInfo()
        .then(data=>{
          this.model12 = data;
          this.loading=false;
        }).catch(error=> this.loading = false)
    },
    handlePeopleList(){
      this.loading = true;
      api.property.Employees.listEmployeesInfo()
        .then(data=>{
          this.model11 = data;
          this.loading=false;
        }).catch(error=> this.loading = false)
    },
    handleSubmit(then,error){
      this.$refs['wateringForm'].validate(valid => {
        if (valid) {
          if (this.watering.id) {
            this.updateWatering(this.watering).then(then).error(error)
          } else {
            this.createWatering(this.watering).then(then).error(error)
          }
        } else {
          this.$Message.error(this.$t('errorText'))
          error()
        }
      })
    },
    handleReset(){
      this.watering.id = ''
      this.actionType = 'add';
      this.$nextTick(()=>this.$refs['wateringForm'].resetFields());
      this.handleAreaList();
      this.handlePeopleList();
    },
    getWatering(id,type){
      this.loading = true;
      this.$refs['wateringForm'].resetFields()
      api.property.Watering.detail(id).then(data => {
        //this.watering = data;
        this.watering.id = data.id;
        this.watering.areaId = data.areaId;
        this.watering.wateringTime = data.wateringTime;
        this.watering.wateringPeople = data.wateringPeople;
        this.watering.remark = data.remark;
        this.handleAreaList();
        this.handleAreaList();
        this.loading = false;
        this.actionType = type;
      }).catch(e => this.loading = false)
    },
    createWatering(watering){
      this.loading = true;
      return api.property.Watering.add(watering)
          .then(response => {
            this.loading = false;
            this.$Message.success(this.$t('successText'))
            return response;
          })
          .catch(e => {
            this.loading = false;
          })
    },
    updateWatering(watering){
      this.loading = true;
      return api.property.Watering.update(watering)
          .then(response => {
            this.loading = false;
            this.$Message.success(this.$t('successText'))
            return response;
          })
          .catch(e => {
            this.loading = false;
          })
    }
  },
  computed: {
    ruleValidate(){
      let validate =  {
      areaId: [{type: 'number', required: true, message: this.$t('property.watering.areaId.required'),trigger: 'blur'}],
     //wateringTime: [{type: 'date', required: true, message: this.$t('property.watering.wateringTime.required'),trigger: 'blur'}],
      wateringPeople: [{type: 'number', required: true, message: this.$t('property.watering.wateringPeople.required'),trigger: 'blur'}],
      remark: [{type: 'string',max: 255, message: this.$t('property.watering.remark.max'),trigger: 'blur'}]
      }
      if(this.actionType == 'edit'){
        this.$refs['wateringForm'].fields.forEach(f => {
          if(f.$children[0].disabled){
            delete validate[f.prop]
          }
        })
      }else if(this.actionType == 'detail'){
        return {}
      }
      return validate;
    }
  }
}
</script>
